import { dialog, modelName, sessionStorageKeyAuthorizationToken, unknownLabel } from '../../../common/const/commonConst';
import { responseType } from '../../../common/type/ResponseType';
import { HandlerOutputType } from '../../../common/type/HandlerType';
import { getSessionStorage } from '../../../common/utils/sessionStorageHandler';
import { nonNullable } from '../../../common/utils/nonNullable';
import { isResponseTypeError, isResponseTypeSessionNotExist } from '../../../common/utils/responseTypeChecker';
import { redirectToLogin } from '../../../common/utils/redirectToLogin';

import { CurrentCarPlaceInfoType } from '../type/CurrentCarPlaceInfoType';
import { RequestParameter } from '../type/RequestParameter';
import { queryGetCurrentCarPlace } from '../api/queryGetCurrentCarPlace';

/**
 * Offseg・G500Liteの車両現在位置一覧を取得する
 */
export const getCurrentCarPlaceHandler = async (requestParams: RequestParameter): Promise<HandlerOutputType<CurrentCarPlaceInfoType[]>> => {
	// 認証トークンを取得する
	const authorizationToken = getSessionStorage(sessionStorageKeyAuthorizationToken);

	if (!authorizationToken) {
		return [dialog.systemError, undefined];
	}

	const getOffsegCurrentCarPlaceInput = {
		authorizationToken: authorizationToken,
		organizationId: requestParams.offsegOrganizationId ? requestParams.offsegOrganizationId : undefined,
		driverId: requestParams.offsegDriverId ? requestParams.offsegDriverId : undefined,
		carId: requestParams.offsegCarId ? requestParams.offsegCarId : undefined,
	};
	console.log(getOffsegCurrentCarPlaceInput);

	const getG500LiteCurrentCarPlaceInput = {
		authorizationToken: authorizationToken,
		organizationId: requestParams.g500LiteOrganizationId ? requestParams.g500LiteOrganizationId : undefined,
		carId: requestParams.g500LiteCarId ? requestParams.g500LiteCarId : undefined,
	};
	console.log(getG500LiteCurrentCarPlaceInput);

	try {
		// Offseg・G500Liteの車両現在位置一覧を取得する
		const [isApiError, getCurrentCarPlaceResult] = await queryGetCurrentCarPlace(
			getOffsegCurrentCarPlaceInput,
			getG500LiteCurrentCarPlaceInput,
			authorizationToken,
		);
		console.log(getCurrentCarPlaceResult);

		if (isApiError || !getCurrentCarPlaceResult || isResponseTypeError(getCurrentCarPlaceResult)) {
			return [dialog.apiError, undefined];
		}

		if (isResponseTypeSessionNotExist(getCurrentCarPlaceResult)) {
			redirectToLogin();
		}

		// 取得結果の存在チェック
		if (
			getCurrentCarPlaceResult.getG500LiteCurrentCarPlaceInfo.responseType === responseType.notExistApiResponseData &&
			getCurrentCarPlaceResult.getOffsegCurrentCarPlaceInfo.responseType === responseType.notExistApiResponseData
		) {
			return [dialog.notExistSearchResult, undefined];
		}

		const currentCarPlaceInfoList: CurrentCarPlaceInfoType[] = [];

		// modelを追加
		getCurrentCarPlaceResult.getOffsegCurrentCarPlaceInfo.currentCarPlaceInfoList.filter(nonNullable).forEach((item) => {
			const currentCarPlaceWithModel = {
				organizationName: item.organizeName || unknownLabel,
				carCode: item.carCode || unknownLabel,
				numberPlate: item.numberPlate || unknownLabel,
				driverName: item.driverName || unknownLabel,
				connectionStatus: item.connectionStatus || unknownLabel,
				receiveDatetime: item.receiveDatetime || unknownLabel,
				lat: item.lat || 0,
				lon: item.lon || 0,
				model: modelName.offseg,
			};
			currentCarPlaceInfoList.push(currentCarPlaceWithModel);
		});

		getCurrentCarPlaceResult.getG500LiteCurrentCarPlaceInfo.currentCarPlaceInfoList.filter(nonNullable).forEach((item) => {
			const currentCarPlaceWithModel = {
				organizationName: item.organizeName || unknownLabel,
				carCode: item.carCode || unknownLabel,
				numberPlate: item.numberPlate || unknownLabel,
				driverName: item.driverName || unknownLabel,
				connectionStatus: item.connectionStatus || unknownLabel,
				receiveDatetime: item.receiveDatetime || unknownLabel,
				lat: item.lat || 0,
				lon: item.lon || 0,
				model: modelName.g500Lite,
			};
			currentCarPlaceInfoList.push(currentCarPlaceWithModel);
		});

		console.log(currentCarPlaceInfoList);
		return [dialog.success, currentCarPlaceInfoList];
	} catch (err: unknown) {
		return [dialog.systemError, undefined];
	}
};
